const header = document.querySelector("[data-cyclon-header]");
if (header) {
  let previousY = window.scrollY;
  let ticking = false;
  const update = () => {
    const currentY = window.scrollY;
    header.classList.toggle("cyclon-site-header--hidden", currentY > previousY && currentY > 180);
    header.classList.toggle("cyclon-site-header--scrolled", currentY > 16);
    previousY = currentY;
    ticking = false;
  };
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  const disclosures = [...header.querySelectorAll("details")];
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const activeDisclosure = [...disclosures]
      .reverse()
      .find((item) => item.open && item.contains(document.activeElement));
    disclosures.forEach((item) => { item.open = false; });
    activeDisclosure?.querySelector(":scope > summary")?.focus();
  });
  document.addEventListener("click", (event) => {
    disclosures.forEach((item) => {
      if (item.open && !item.contains(event.target)) item.open = false;
    });
  });
}

const normalizeHeroServiceCta = () => {
  document.querySelectorAll('.cyclon-hero__actions a[href*="/pages/servicio"]').forEach((link) => {
    link.setAttribute("href", "/pages/contact");
    link.style.setProperty("display", "inline-flex", "important");
  });
};

const replaceText = (selector, nextText) => {
  const element = document.querySelector(selector);
  if (element && element.textContent.trim() !== nextText) {
    element.textContent = nextText;
  }
};

const normalizeHomeCopy = () => {
  replaceText(".cyclon-hero--commerce h1", "Tu equipo, listo para moverse.");
  replaceText("#cyclon-categories-heading", "Para salir con todo.");
  replaceText("#cyclon-paths-heading", "Comprás. Retirás. Volvés cuando lo necesitás.");

  const heroCopy = document.querySelector(".cyclon-hero--commerce .cyclon-copy");
  if (heroCopy) {
    heroCopy.innerHTML = "<p>Computadoras, accesorios, cargadores, cables, repuestos y servicio técnico en Galería Jardín.</p>";
  }

  const categoryCopy = document.querySelector("#cyclon-categories-heading + .cyclon-section-heading__copy");
  if (categoryCopy) {
    categoryCopy.textContent = "Lo básico, lo técnico y lo que salva el día.";
  }

  const pathsCopy = document.querySelector("#cyclon-paths-heading + .cyclon-section-heading__copy");
  if (pathsCopy) {
    pathsCopy.textContent = "Productos, repuestos y servicio técnico con un lugar real donde resolver.";
  }
};

const normalizeCyclonHome = () => {
  normalizeHeroServiceCta();
  normalizeHomeCopy();
};

normalizeCyclonHome();
document.addEventListener("DOMContentLoaded", normalizeCyclonHome);
